/**
 * Modal
 */

/**
 * Closes or opens (toggles) the modal for the supplied toggle element.
 *
 * @param {*} toggle    A modal toggle element
 * @param {*} doNotOpen Determines if the function should be unable to open the modal
 * @returns
 */
function sohova_modal_toggle(toggle, doNotOpen = false) {
    if (doNotOpen && !toggle.classList.contains('-open')) {
        return;
    }

    toggle.classList.toggle('-open');
    toggle.parentElement.classList.toggle('-open');
    let modal = toggle.nextElementSibling;
    if (modal.style.display === 'block') {
        modal.style.display = 'none';
        toggle.setAttribute('aria-expanded', false);
    } else {
        modal.style.display = 'block';
        toggle.setAttribute('aria-expanded', true);
    }
}

function sohova_modal_close_all() {
    let modal_toggle = document.getElementsByClassName('js-modal-toggle');
    for (let i = 0; i < modal_toggle.length; i++) {
        sohova_modal_toggle(modal_toggle[i], true);
    }
}

// Make the modal change its state when the toggle button is clicked
{
    let modal_toggle = document.getElementsByClassName('js-modal-toggle');
    for (let i = 0; i < modal_toggle.length; i++) {
        modal_toggle[i].addEventListener('click', function () {
            sohova_modal_toggle(this);
        });
    }
}

// Make the modal close when the close button is clicked
{
    let modal_close_button = document.getElementsByClassName(
        'js-modal-close-button'
    );
    for (let i = 0; i < modal_close_button.length; i++) {
        modal_close_button[i].addEventListener('click', function () {
            let toggle = this.parentElement.previousElementSibling;
            sohova_modal_toggle(toggle);
            toggle.focus();
        });
    }
}

// Make the modal close when the overlay is clicked
{
    let modal_overlay = document.getElementsByClassName('js-modal-overlay');
    for (let i = 0; i < modal_overlay.length; i++) {
        modal_overlay[i].addEventListener('click', function () {
            let toggle = this.nextElementSibling;
            sohova_modal_toggle(toggle);
            toggle.focus();
        });
    }
}

// Make all modals close when the ESC key is pressed
document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ('key' in evt) {
        isEscape = evt.key === 'Escape' || evt.key === 'Esc';
    } else {
        isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
        sohova_modal_close_all();
    }
};
